import { Link } from "react-router-dom";
import Header from "./Header";
import useState from "react-usestateref";
import Footer from "./Footer";
import tokenomicsShellStyle from "../styles/tokenomicsShellStyle";
import HeroInteractive from "../components/HeroInteractive";
import SeoHead from "../components/SeoHead";
import ArcadeMachine from "../components/illustrations/ArcadeMachine";
import "../components/illustrations/illustrations.css";
import "../components/illustrations/concepts.css";

const Landing = () => {
  const [futureToggleBtn, setFutureToggleBtn, futureToggleBtnRef] =
    useState("blockchain");

  const handleToggle = (data) => {
    setFutureToggleBtn(data);
  };

  return (
    <div className="tokenomics-shell" style={tokenomicsShellStyle}>
      <SeoHead
        title="Atheriam - Agentic AI Layer 1 Blockchain for Gaming"
        description="Atheriam is an Agentic AI-powered Layer 1 blockchain built for Web3 gaming - near-zero fees, scalable gameplay, smart contracts, and intelligent game agents."
        path="/"
      />
      <Header />

      <main className="landing-main">
        {/* hero */}
        <section className="hero">
          <div className="container-fluid container-md hero-inner">
            <div className="row hero-row">
              <div className="col-lg-6 hero-copy">
                <p className="hero-brand">ATHERIAM</p>
                <h1 className="hero-title">
                  The Ultimate Blockchain for Gaming
                </h1>
                <p className="hero-content">
                  Unstoppable speed. Unbreakable security. Unmatched rewards.
                  Atheriam powers Web3 gaming with Agentic AI and near-zero fee
                  blockchain infrastructure.
                </p>
                <div className="hero-btn-wrap">
                  <Link to="/blockchain" className="landing-btn-secondary">
                    Explore Atheriam
                  </Link>
                  <Link to="/tokenomics" className="landing-btn-primary">
                    View Tokenomics
                  </Link>
                </div>
                {/* Launch announcement */}
                <div className="launching-soon-section" role="status" aria-label="Launching October 9 at TOKEN2049 Singapore">
                  <span className="launching-soon-section__beam" aria-hidden="true" />
                  <span className="launching-soon-section__ring" aria-hidden="true" />
                  <span className="launching-soon-section__spark launching-soon-section__spark--a" aria-hidden="true" />
                  <span className="launching-soon-section__spark launching-soon-section__spark--b" aria-hidden="true" />
                  <span className="launching-soon-section__spark launching-soon-section__spark--c" aria-hidden="true" />
                  <span className="launching-soon-section__spark launching-soon-section__spark--d" aria-hidden="true" />
                  <div className="launching-soon-text">
                    <span className="launching-soon-text__live">
                      <i />
                      Live drop
                    </span>
                    <span className="launching-soon-text__copy">
                      <span className="launching-soon-text__kicker">Launching</span>
                      <strong>Oct 9</strong>
                      <em>TOKEN2049 · Singapore</em>
                    </span>
                    <span className="launching-soon-text__shimmer" aria-hidden="true" />
                    <span className="launching-soon-text__scan" aria-hidden="true" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="hero-right">
                  <HeroInteractive />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* future */}
        <section className="future">
          <div className="container-fluid container-md">
            <h3 className="landing-subtitle ln-ft-title">
              The Future of Gaming Runs on Atheriam
            </h3>
            <div className="text-center mt-4">
              <div className="future-btn-wrap">
                <div
                  className={`future-toggle-btn ${
                    futureToggleBtn === "blockchain" ? "active" : ""
                  }`}
                  onClick={() => handleToggle("blockchain")}
                >
                  Blockchain
                </div>
                <div
                  className={`future-toggle-btn ${
                    futureToggleBtn === "gaming" ? "active" : ""
                  }`}
                  onClick={() => handleToggle("gaming")}
                >
                  Gaming
                </div>
              </div>
            </div>

            {futureToggleBtnRef.current === "blockchain" ? (
              <>
                <div className="row mx-0 ft-row ft-row-one">
                  <div className="col-md-7 ft-row-one-animate">
                    <ArcadeMachine mode="security" />
                  </div>
                  <div className="col-md-5 ">
                    <h3 className="ft-row-title">Unmatched Speed & Security</h3>
                    <p className="ft-row-content">
                      Atheriam ensures instant transactions with next-level
                      encryption, keeping every play and reward secure. No
                      delays, no risks - just seamless gaming powered by
                      blockchain technology.
                    </p>
                    <div className="hero-btn-wrap">
                      <Link to="/blockchain" className="landing-btn-primary">
                        Explore Blockchain
                      </Link>
                      <Link to="/whitepaper" className="landing-btn-secondary">
                        Know More
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="row mx-0 ft-row ft-row-two">
                  <div className="col-md-5 ">
                    <h3 className="ft-row-title ft-row-txt-rgt">
                      Provably Fair & Transparent
                    </h3>
                    <p className="ft-row-content ft-row-txt-rgt">
                      Every game outcome is recorded on-chain, ensuring fairness
                      and trust. Smart contracts eliminate manipulation, giving
                      players full confidence in every match they play.
                    </p>
                    <div className="hero-btn-wrap ft-row-justify-end">
                      <Link to="/blockchain" className="landing-btn-primary">
                        See How It Works
                      </Link>
                      <Link to="/whitepaper" className="landing-btn-secondary">
                        Know More
                      </Link>
                    </div>
                  </div>

                  <div className="col-md-7 ft-row-one-animate">
                    <ArcadeMachine mode="fair" />
                  </div>
                </div>

                <div className="row mx-0 ft-row ft-row-three">
                  <div className="col-md-7 ft-row-three-animate">
                    <ArcadeMachine mode="vault" />
                  </div>
                  <div className="col-md-5 ">
                    <h3 className="ft-row-title">Own Your Assets</h3>
                    <p className="ft-row-content">
                      Players have full control over in-game assets, earnings,
                      and rewards. With blockchain-backed ownership, assets can
                      be traded, withdrawn, or used without restrictions.
                    </p>
                    <div className="hero-btn-wrap">
                      <Link to="/tokenomics" className="landing-btn-primary">
                        Discover More
                      </Link>
                      <Link to="/whitepaper" className="landing-btn-secondary">
                        Know More
                      </Link>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row mx-0 ft-row ft-row-one">
                  <div className="col-lg-7 col-md-6 ft-row-one-animate">
                    <ArcadeMachine mode="gaming" />
                  </div>
                  <div className="col-lg-5 col-md-6">
                    <h3 className="ft-row-title">
                      Next-Level Gaming Experience
                    </h3>
                    <p className="ft-row-content">
                      Atheriam merges blockchain with immersive gameplay,
                      delivering high-energy action with unmatched security.
                      Every match, quest, and reward is transparent and verifiable.
                    </p>
                    <div className="hero-btn-wrap">
                      <Link to="/gaming" className="landing-btn-primary">
                        Play Now
                      </Link>
                      <Link to="/whitepaper" className="landing-btn-secondary">
                        Know More
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="row mx-0 ft-row ft-row-two gm-rw-two">
                  <div className="col-lg-5 col-md-6">
                    <h3 className="ft-row-title gm-rw-two-title">
                      Instant Payouts with No Middlemen
                    </h3>
                    <p className="ft-row-content ft-row-txt-rgt">
                      Withdraw rewards instantly with blockchain technology. No
                      waiting periods, no hidden fees - just fast, direct payouts
                      that put players in control of their funds.
                    </p>
                    <div className="hero-btn-wrap ft-row-justify-end">
                      <Link to="/gaming" className="landing-btn-primary">
                        Claim Rewards
                      </Link>
                      <Link to="/tokenomics" className="landing-btn-secondary">
                        Know More
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-7 col-md-6 gm-rw-col ft-row-one-animate">
                    <ArcadeMachine mode="payout" />
                  </div>
                </div>

                <div className="row mx-0 ft-row ft-row-three gm-row-three">
                  <div className="col-lg-7 col-md-6 gm-rw-col ft-row-three-animate">
                    <ArcadeMachine mode="rewards" />
                  </div>
                  <div className="col-lg-5 col-md-6">
                    <h3 className="ft-row-title">
                      Exclusive Rewards and Bonuses
                    </h3>
                    <p className="ft-row-content">
                      Earn blockchain-powered rewards, loyalty perks, and
                      exclusive bonuses. Atheriam's fair reward system ensures
                      every player gets the most from their gaming experience.
                    </p>
                    <div className="hero-btn-wrap">
                      <Link to="/gaming" className="landing-btn-primary">
                        Start Playing
                      </Link>
                      <Link to="/ico" className="landing-btn-secondary">
                        Know More
                      </Link>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </section>

        {/* features */}
        <section className="features">
          <div className="container-fluid container-md">
            <h3 className="landing-subtitle fea-title">
              Game Changing Features Powered by Atheriam
            </h3>
            <p className="landing-subcontent text-center mt-3">
              Blockchain-powered gaming with speed, security, and
              transparency.
            </p>

            <div className="row mx-0 fea-row g-lg-5 g-3">
              {/* row one */}
              <div className="col-lg-3">
                <div className="fea-cards fea-one">
                  <h5>Unbreakable Security</h5>
                  <p>
                    Blockchain encryption secures every transaction and reward,
                    making them tamper-proof and verifiable.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 fea-col-none"></div>
              <div className="col-lg-3">
                <div className="fea-cards fea-two">
                  <h5>Instant Transactions</h5>
                  <p>
                    No delays, no waiting - Atheriam’s ultra-fast blockchain
                    processes transactions in seconds with minimal fees.
                  </p>
                </div>
              </div>

              {/* row two */}
              <div className="col-lg-3">
                <div className="fea-cards fea-three">
                  <h5>Provably Fair Gaming</h5>
                  <p>
                    Every play and outcome is recorded on-chain, ensuring true
                    fairness and transparency in every game.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 fea-col-none"></div>
              <div className="col-lg-3">
                <div className="fea-cards fea-four">
                  <h5>No Middlemen, No Limits</h5>
                  <p>
                    Enjoy direct transactions with complete control over funds.
                    No third parties, no restrictions - just seamless gaming
                    freedom.
                  </p>
                </div>
              </div>

              {/* row three */}
              <div className="col-lg-3">
                <div className="fea-cards fea-five">
                  <h5>Earn and Trade Assets</h5>
                  <p>
                    Win real digital assets that you can trade, sell, or use
                    across different platforms. Your rewards, your way.
                  </p>
                </div>
              </div>

              <div className="fea-animate illus-fea-wrap">
                <ArcadeMachine mode="core" />
              </div>
            </div>
          </div>
        </section>

        {/* experience */}
        <section className="experience">
          <div className="container-fluid container-md">
            <div className="text-center">
              <span className="exp-span">Seamless, Secure, and Instant</span>
            </div>
            <h3 className="landing-subtitle exp-title">
              Experience Next-Level Gaming on Blockchain
            </h3>
            <p className="landing-subcontent text-center">
              Atheriam makes gaming fast, secure, and truly yours.
            </p>

            <div className="row mx-0 g-lg-3 g-4 exp-row">
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="exp-cards card-one">
                  <img
                    src={require("../assets/exp-img-one.webp")}
                    alt=""
                    className="exp-img-one"
                  />
                  <h6 className="exp-card-title">Connect Your Wallet</h6>
                  <p className="exp-card-content">
                    Securely link your crypto wallet and dive into seamless
                    blockchain gaming.
                  </p>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="exp-cards card-two">
                  <h6 className="exp-card-title">Choose Your Game</h6>
                  <p className="exp-card-content">
                    Explore a variety of games, all powered by blockchain
                    technology for unmatched security, fairness, and instant
                    transactions.
                  </p>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="exp-cards card-three">
                  <div>
                    <h6 className="exp-card-title">Start Playing</h6>
                    <p className="exp-card-content">
                      Jump into matches with full transparency and provable
                      fairness.
                    </p>
                  </div>
                  <img
                    src={require("../assets/exp-img-three.webp")}
                    alt=""
                    className="exp-img-three"
                  />
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="exp-cards card-four">
                  <h6 className="exp-card-title">
                    Join the Future of Gaming
                  </h6>

                  {/* <video
                    muted
                    loop
                    playsInline
                    autoPlay
                    className="exp-img-four"
                  >
                    <source
                      src="https://res.cloudinary.com/dmjw7pe6k/video/upload/v1741266159/exp-img-four_wgrpdg.mp4"
                      type="video/mp4"
                    />
                  </video> */}

                  <img
                    src={require("../assets/exp-img-four.webp")}
                    alt=""
                    className="exp-img-four"
                  />
                </div>
              </div>

              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="exp-cards card-five">
                  <div className="exp-img-five-wrap">
                    <img
                      src={require("../assets/exp-img-five.webp.gif")}
                      alt=""
                    />
                  </div>
                  <h6 className="exp-card-title">Win Real Digital Rewards</h6>
                  <p className="exp-card-content">
                    Earn blockchain-backed rewards that you truly own and can
                    trade.
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-4 col-sm-6">
                <div className="exp-cards card-six">
                  <h4>Powered by Atheriam Blockchain</h4>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="exp-cards card-seven">
                  <div>
                    <h6 className="exp-card-title">Claim Rewards Anytime</h6>
                    <p className="exp-card-content exp-cd-seven">
                      Withdraw rewards instantly with no middlemen or hidden
                      fees.
                    </p>
                  </div>
                  <img
                    src={require("../assets/exp-img-seven.webp")}
                    alt=""
                    className="exp-img-seven"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* join */}
        <section className="join">
          <div className="container-fluid container-md">
            <div className="text-center">
              <span className="exp-span">Take the Next Step</span>
            </div>
            <h3 className="landing-subtitle jn-title">
              Join the Future of Gaming with Atheriam
            </h3>
            <p className="landing-subcontent jn-content">
              Experience unmatched security, speed, and fairness in
              blockchain-powered gaming. Play now and take full control of your
              rewards.
            </p>
            <div className="text-center jn-btn-wrap">
              <Link to="/gaming" className="landing-btn-primary jn-btn">
                Enter the Future of Gaming
              </Link>
            </div>
            <div className="join-animate-wrap">
              <div className="join-animate illus-join-wrap">
                <ArcadeMachine mode="token" />
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  );
};

export default Landing;
